import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { X } from 'lucide-react';

const VideoModal = ({ isOpen, onClose, videoUrl, title = "Ferntree Overview" }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[900px] bg-[var(--bg-card)] border-[var(--border-light)] p-0">
        <DialogHeader className="p-6 pb-4">
          <DialogTitle className="text-2xl font-bold text-[var(--text-primary)]">{title}</DialogTitle>
        </DialogHeader>
        <div className="aspect-video bg-black rounded-b-lg overflow-hidden">
          {videoUrl ? (
            <iframe
              src={videoUrl}
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-white">
              <div className="text-center">
                <div className="text-6xl mb-4">▶</div>
                <p className="text-lg">Video placeholder</p>
                <p className="text-sm text-gray-400 mt-2">Replace with actual video URL</p>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;